import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { useCart } from "../../context/cart";
import axios from "axios";
import MiniCart from "../../pages/MiniCart";
import LoginModalPopUp from "../../pages/LoginModalPopUp";
import { useWishlist } from "../../context/WishlistContext";
import GoogleReviews from "../../pages/GoogleReviews";
import GoogleReviewsCustom from "../../pages/GoogleReviewsCustom";
import { toast } from "react-toastify";
export default function Nav() {
  const { wishlist } = useWishlist();
  const [device, setDevice] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [auth, setAuth] = useAuth();
  const [cart_data] = useCart();
  const [searchVal, setSearchVal] = useState("");
  const [loader, setLoader] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [searchDropdown, setSearchDropdown] = useState(true);
  const [userId, setUserId] = useState(auth?.user?.id);
  const [show, setShow] = useState(false);
  const [searchHistoryInfo, setSerachHistoryInfo] = useState(
    JSON.parse(localStorage.getItem("searchHistoryInfo"))
      ? JSON.parse(localStorage.getItem("searchHistoryInfo"))
      : []
  );

  let active = {
    textDecoration: "underline",
  };

  let activeClassName = "active";
  let defoltClassName = "";

  const [isActive, setActive] = useState("false");

  const ToggleClass = () => {
    setActive(!isActive);
  };

  const handleLogout = async () => {
    setAuth({
      ...auth,
      user: null,
      token: "",
    });
    localStorage.removeItem("auth");
    localStorage.removeItem("country_data");
    localStorage.removeItem("country_currency");
    /* localStorage.removeItem("cart"); 
    http://hemant/chaashnicouture/api/v1/auth/logout' */
    localStorage.removeItem("cart");
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/auth/logout?user=${userId}`
    );
    navigate(0);
    toast.success("Logout Successful!", {
      style: {
        background: "black",
        color: "white",
      },
    });
  };

  //Search Function by Sanjay
  const handleSearch = async (e) => {
    const searchData = await e.target.value;
    setKeyword(searchData);
    if (searchData) {
      setSearchDropdown(true);
      if (searchData.length >= 3) {
        setLoader(true);
        try {
          let { data } = await axios.get(
            `${process.env.REACT_APP_API_URL}/products/header-search?name=${searchData}`
          );
          if (data) {
            setLoader(false);
            setSearchVal(data);
          } else {
            //console.log(data);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setSearchVal("");
      }
    }
  };

  function desSplit(str) {
    const tags = /<[^>]*>/g;
    const output = str.replace(tags, "").substring(0, 150);
    return output + "...";
  }

  //handleSearchSubmit

  useEffect(() => {
    localStorage.setItem(
      "searchHistoryInfo",
      JSON.stringify(searchHistoryInfo)
    );
  }, [searchHistoryInfo]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      let existingSearchItem = localStorage.getItem("searchHistoryInfo");
      if (!existingSearchItem.includes(keyword)) {
        setSerachHistoryInfo([...searchHistoryInfo, keyword]);
      }
      onBlur();
      navigate(`/search?q=${keyword}`);
    }
  };
  const delayedCloseMenu = () => {
    setTimeout(() => {
      setSearchDropdown(false);
    }, 200);
  };

  const onBlur = () => delayedCloseMenu();
  const onClick = () => setSearchDropdown(true);

  const [isMenuActive, setMenuActive] = useState("false");
  const ToggleMenu = () => {
    //alert("hi")
    setMenuActive(!isMenuActive);
  };

  const [menuCategory, setMenuCategory] = useState([]);

  const handelCatagory = (category) => {
    setMenuCategory(menuCategory === category ? [] : category);
  };

  // Add and Remove Class on scroll
  const [scrolltopdata, setscrolltopdata] = useState("");

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 5) {
        setscrolltopdata("");
      } else {
        setscrolltopdata("scrolled");
      }
    });
    if (location.hash === "#login") {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    if (location.hash === "#login") {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [location]);
  useEffect(() => {
    // handelCatagory()
  }, [menuCategory]);
  //End responsive menu

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      if (width <= 200) {
        setDevice("mobile");
      } else if (width > 200 && width <= 1200) {
        setDevice("tablet");
      } else {
        setDevice("desktop");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [ismenuActive, setIsmenuActive] = useState(false);

  const handleClick = () => {
    setIsmenuActive(!ismenuActive);
  };
  const handleClickSearch = () => {
  setKeyword("");
  setSearchVal([]);
  setSearchDropdown(false);
  };

  const [isCartActive, setIsCartActive] = useState(false);

  const toggleCartClass = () => {
    setIsCartActive(!isCartActive);
  };


  const[googleReview, setGoogleReview] = useState(false);

  const GoogleHandleClick = () => {
    setGoogleReview(!googleReview)
  }


  return (
    <>
      <div
        className={isMenuActive ? "header-overlay" : "header-overlay active"}
        onClick={ToggleMenu}
      >
        <span className="close-cart">×</span>
      </div>
      <div className="mobile-header">
        <div className="container">
          <div className="header-logo">
            <div className="site-logo">
              <Link className="navbar-brand" to="/">
                <img
                  src="/images/logo-chaashnicouture.png"
                  width="181px"
                  height="50px"
                  alt="Chaashni Couture"
                  title="Chaashni by Maansi & Ketan"
                  loading="lazy"
                />
                {/* <div className="brand-box">A unit of M/s ANTYA</div> */}
              </Link>
            </div>
          </div>
          {device === "mobile" ||
            (device === "tablet" && (
              <div className="user-icons mobile-user-icons">
                <div className="cart">
                  <span onClick={toggleCartClass}>
                    <i className="fa-solid fa-cart-shopping"></i>
                    <span className="cart-count">
                      {`${cart_data ? "(" + cart_data.length + ")" : "0"}`}
                    </span>
                  </span>
                  {/* <div className={isActive ? "minicart-box" : "minicart-box active"}><MiniCart /></div> */}

                  <MiniCart
                    isCartActive={isCartActive}
                    toggleCartClass={toggleCartClass}
                  />
                </div>
              </div>
            ))}
          <div className="burger-icon" onClick={ToggleMenu}>
            <a href="#" onClick={(e) => { e.preventDefault(); handleClick(); }}>
              <i className="fa fa-bars" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
      <nav
        datashow={ismenuActive ? "active" : ""}
        className={`${
          isMenuActive
            ? "navbar navbar-expand-lg bg-custom-white navbar-light fixed-top custom-menu new-design-nav"
            : "navbar navbar-expand-lg bg-custom-white navbar-light fixed-top custom-menu new-design-nav show-menu"
        } ${scrolltopdata}`}
      >
        {/* JSON.stringify(auth,null,4) */}
        <div className="container">
          <div className="collapse navbar-collapse" id="mynavbar">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mynavbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <ul className="navbar-nav">
              <li className="megamenu nav-item">
                <a className="nav-link" style={{ textTransform: "uppercase" }}>
                  Shop <i className="fa-solid fa-angle-down"></i>
                </a>
                <ul>
                  <li className="menu-none menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children">
                    <ul>
                      <li
                        className={`${
                          menuCategory === "indo-westerns"
                            ? "open-sub-menu"
                            : "none"
                        }`}
                      >
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/indo-westerns?category_product=indo-westerns_indo-westerns-the-ruhani-edit_indo-westerns-the-manchali-edit_indo-westerns-the-glam-edit&orderBy=default"
                        >
                          Indo Westerns
                        </NavLink>
                        <ul className="submenu-box">
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/indo-westerns?category_product=indo-westerns-the-ruhani-edit&orderBy=default"
                            >
                              <span>The Ruhani Edit (Co-ord Sets)</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/indo-westerns?category_product=indo-westerns-the-manchali-edit&orderBy=default"
                            >
                              <span>The Manchali Edit (Prints)</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/indo-westerns?category_product=indo-westerns-the-glam-edit&orderBy=default"
                            >
                              <span>The Glam Edit</span>
                            </NavLink>
                          </li>
                        </ul>
                        <span
                          className="menu-right-icon"
                          onClick={() => {
                            handelCatagory("indo-westerns");
                          }}
                        >
                          <i className="fa-solid fa-angle-down"></i>
                        </span>
                      </li>
                      <li>
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/festive-flair?category_product=festive-flair&orderBy=default"
                        >
                          Festive Flair (Kurta Sets)
                        </NavLink>
                      </li>
                      <li
                        className={`${
                          menuCategory === "Lehengas" ? "open-sub-menu" : "none"
                        }`}
                      >
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/lehengas?orderBy=default&category_product=lehengas_printed-lehengas_the-signature-edit_the-regal-collection_the-timeless-collection_the-sleek-edit"
                        >
                          <span>Lehengas</span>
                        </NavLink>
                        <ul className="submenu-box">
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/lehengas?orderBy=default&category_product=printed-lehengas"
                            >
                              <span>Printed Lehengas</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/lehengas?orderBy=default&category_product=the-signature-edit"
                            >
                              <span>The Signature Edit</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/lehengas?orderBy=default&category_product=the-regal-collection"
                            >
                              <span>The Regal Collection</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/lehengas?orderBy=default&category_product=the-timeless-collection"
                            >
                              <span>The Timeless Collection</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/lehengas?orderBy=default&category_product=the-sleek-edit"
                            >
                              <span>The Sleek Edit</span>
                            </NavLink>
                          </li>
                        </ul>
                        <span
                          className="menu-right-icon"
                          onClick={() => {
                            handelCatagory("Lehengas");
                          }}
                        >
                          <i className="fa-solid fa-angle-down"></i>
                        </span>
                      </li>
                      <li>
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/lehenga-sarees?category_product=lehenga-sarees&orderBy=default"
                        >
                          <span>Lehenga Sarees</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/stitched-sarees?category_product=stitched-sarees&orderBy=default"
                        >
                          <span>Stitched Sarees</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/sarees?category_product=sarees&orderBy=default"
                        >
                          <span>Sarees</span>
                        </NavLink>
                      </li>
                      <li
                        className={`${
                          menuCategory === "gowns" ? "open-sub-menu" : "none"
                        }`}
                      >
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/gowns?category_product=gowns_gowns-signature-edit_gowns-the-timeless-collection&orderBy=default"
                        >
                          Gowns
                        </NavLink>
                        <ul className="submenu-box">
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/gowns?orderBy=default&category_product=gowns-signature-edit"
                            >
                              <span>The Signature Edit</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className={({ isActive }) =>
                                isActive ? activeClassName : defoltClassName
                              }
                              onClick={ToggleMenu}
                              to="/category/gowns?orderBy=default&category_product=gowns-the-timeless-collection"
                            >
                              <span>The Timeless Collection</span>
                            </NavLink>
                          </li>
                        </ul>
                        <span
                          className="menu-right-icon"
                          onClick={() => {
                            handelCatagory("gowns");
                          }}
                        >
                          <i className="fa-solid fa-angle-down"></i>
                        </span>
                      </li>
                      <li>
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? activeClassName : defoltClassName
                          }
                          onClick={ToggleMenu}
                          to="/category/the-chic-edit?orderBy=default&category_product=the-chic-edit"
                        >
                          <span>The Chic Edit (Westerns)</span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <ul>
                      <li className="red has-bg sale-bg hide-menu menu-item menu-item-type-custom menu-item-object-custom  border-bottom-none">
                        {/* <NavLink className={({ isActive }) => isActive ? activeClassName + "notin-mobile" : defoltClassName + "notin-mobile"} to="/category/sample-sale"> <span>SALE!</span> </NavLink> */}
                        <NavLink
                          className={({ isActive }) =>
                            isActive
                              ? activeClassName + " img-link"
                              : defoltClassName + " img-link"
                          }
                          onClick={ToggleMenu}
                          to="/category/sample-sale?category_product=sample-sale&orderBy=default"
                        >
                          <img
                            src="/images/Small-Ad-Banner.jpg"
                            alt=""
                            className="li-img"
                            width="180px"
                            height="181px"
                          />
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li
                className={`nav-item ${
                  menuCategory.includes("ready-to-ship") ? "open-sub-menu" : ""
                }`}
              >
                <NavLink
                  className={({ isActive }) =>
                    isActive ? activeClassName : defoltClassName
                  }
                  onClick={ToggleMenu}
                  to="/category/shop?shipping=7+Days"
                  style={{ textTransform: "uppercase" }}
                >
                  Ready To Ship <i className="fa-solid fa-angle-down"></i>
                </NavLink>
                <ul className="submenu-box">
                <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/indo-westerns?shipping=Within 7 days&category_product=indo-westerns_indo-westerns-the-ruhani-edit_indo-westerns-the-manchali-edit_indo-westerns-the-glam-edit"
                    >
                      Indo Westerns
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/festive-flair?category_product=festive-flair&orderBy=default&shipping=Within+7+days"
                    >
                      Festive Flair (Kurta Sets)
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/lehengas?shipping=Within 7 days&category_product=lehengas_printed-lehengas_the-signature-edit_the-regal-collection_the-timeless-collection_the-sleek-edit"
                    >
                      Lehengas
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/lehenga-sarees?category_product=lehenga-sarees&orderBy=default&shipping=Within+7+days"
                    >
                      Lehenga Sarees
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/stitched-sarees?category_product=stitched-sarees&orderBy=default&shipping=Within+7+days"
                    >
                      Stitched Sarees
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/sarees?category_product=sarees&orderBy=default&shipping=Within+7+days"
                    >
                      Sarees
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/gowns?shipping=Within 7 days&category_product=gowns_gowns-signature-edit_gowns-the-timeless-collection"
                    >
                      Gowns
                    </NavLink>
                  </li>
                  
                 
                  
                  
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                      onClick={ToggleMenu}
                      to="/category/the-chic-edit?orderBy=default&category_product=the-chic-edit&shipping=Within+7+days"
                    >
                      The Chic Edit (Westerns)
                    </NavLink>
                  </li>
                </ul>
                <span
                  className="menu-right-icon"
                  onClick={() => {
                    handelCatagory("ready-to-ship");
                  }}
                >
                  <i className="fa-solid fa-angle-down"></i>
                </span>
              </li>
            </ul>

            <Link className="navbar-brand" to="/">
              <img
                src="/images/logo-chaashnicouture.png"
                width="181px"
                height="50px"
                alt="Chaashni Couture"
                title="Chaashni by Maansi & Ketan"
                loading="lazy"
              />
              {/* <div className="brand-box">A unit of M/s ANTYA</div> */}
            </Link>

            <form className="d-flex searchform " onSubmit={handleSearchSubmit}>
              <input
                className={"form-control " + (loader ? "search-loader" : "")}
                type="text"
                placeholder="Search for Products and Categories"
                onChange={handleSearch}
                value={keyword}
                onBlur={onBlur}
                onClick={onClick}
                maxLength={100}
              />
              <span className="close-search-btn searchfordesktop" onClick={handleClick}>&times;</span>
              
              {keyword && (
              <span className="close-search-btn searchformobile" onClick={handleClickSearch}>&times;</span>
              )} 
              
              {searchDropdown &&
                (searchVal?.products?.length > 0 ||
                  searchVal?.category?.length > 0) && (
                  <div className="search-result">
                    <ul>
                      {searchVal?.category?.map((sData, i) => {
                        return (
                          <li key={i}>
                            <Link
                              target="_blank"
                              to={`/category/${sData.slug}`}
                            >
                              <span className="search_result_content">
                                <span className="search_result_title">
                                  {sData.name}
                                </span>
                              </span>
                            </Link>
                          </li>
                        );
                      })}
                      {searchVal?.products?.map((sData, i) => {
                        return (
                          <li key={i}>
                            <Link target="_blank" to={`/product/${sData.slug}`}>
                              <span className="search_result_image">
                                <img
                                  src={`${process.env.REACT_APP_IMAGE_URL}/product/thumbnail/${sData.thumbnail}`}
                                  alt=""
                                />
                              </span>
                              <span className="search_result_content">
                                <span className="search_result_title">
                                  {sData.name}
                                </span>
                                <span className="search_result_sku">
                                  SKU: {sData.code}
                                </span>
                                <span className="search_result_excerpt">
                                  {desSplit(sData.details)}
                                </span>
                              </span>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
            </form>
            <div className="d-flex user-icons">
              <div className="insta-icon"><a href="https://www.instagram.com/chaashni.couture/" target="_blank"><i className="fa-brands fa-instagram"></i></a></div>
              <div className="search-icon">
                <i
                  className="fa-solid fa-magnifying-glass"
                  onClick={handleClick}
                ></i>
              </div>
              <div className={`profile ${auth?.user ? "dropdown-icon" : ""} `}>
                {auth?.user ? (
                  <span>
                    <i className="fa-regular fa-user"></i>{" "}
                    <span className="formobile">
                      {auth?.user?.name.split(" ")[0]}
                    </span>
                  </span>
                ) : (
                  <Link to="/loginsignup">
                    <i className="fa-regular fa-user"></i>
                  </Link>
                )}
                {auth?.user ? (
                  <ul>
                    <li
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <NavLink onClick={ToggleMenu} to="/myorders">
                        <span>My Orders</span>
                      </NavLink>
                    </li>
                    <li
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <NavLink onClick={ToggleMenu} to="/measurements">
                        <span>My Measurements</span>
                      </NavLink>
                    </li>
                    <li
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <NavLink onClick={ToggleMenu} to="/my-account-detail">
                        <span>My Account details</span>
                      </NavLink>
                    </li>
                    <li
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <NavLink onClick={ToggleMenu} to="/my-address">
                        <span>My Address</span>
                      </NavLink>
                    </li>
                    {/* <li
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <NavLink onClick={ToggleMenu} to="/support-ticket">
                        <span>Support Ticket</span>
                      </NavLink>
                    </li> */}
                    <li style={{display:"none"}}
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <NavLink onClick={ToggleMenu} to="/tryondetail">
                        <span>My AI Virtual Try-On</span>
                      </NavLink>
                    </li>
                    <li
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <NavLink onClick={ToggleMenu} to="/checkout/">
                        <span>Checkout</span>
                      </NavLink>
                    </li>
                    <li
                      className={({ isActive }) =>
                        isActive ? activeClassName : defoltClassName
                      }
                    >
                      <Link
                        onClick={() => {
                          handleLogout();
                          ToggleMenu();
                        }}
                        to="/"
                      >
                        Logout
                      </Link>
                    </li>
                  </ul>
                ) : (
                  ""
                )}
              </div>
              {auth?.user ? (
                <div className="wishlist">
                  <Link to="/wishlist/">
                    <i className="fa-regular fa-heart"></i>
                    <span className="heart-count">
                      {` ${
                        wishlist.length > 0 ? "(" + wishlist.length + ")" : ""
                      }`}
                    </span>
                  </Link>
                </div>
              ) : (
                ""
              )}

              {device === "desktop" && (
                <div className="cart">
                  <span onClick={toggleCartClass}>
                    <i className="fa-solid fa-cart-shopping"></i>
                    <span className="cart-count">
                      {`${cart_data ? "(" + cart_data.length + ")" : "0"}`}
                    </span>
                  </span>
                  {/* <div className={isActive ? "minicart-box" : "minicart-box active"}><MiniCart /></div> */}
                  <MiniCart
                    isCartActive={isCartActive}
                    toggleCartClass={toggleCartClass}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
      <LoginModalPopUp show={show} handleClose={() => setShow(false)} />
        <div className="google-review-button" onClick={GoogleHandleClick}><span>★</span> Reviews</div>
        

        {googleReview && (
          <div className="google-reviews-wrap">
            <span className="overlay" onClick={GoogleHandleClick}><span></span></span>
            <div className='google-reviews'>
              <div className='close-btn' onClick={GoogleHandleClick}>&times;</div>
             <GoogleReviews /> 
             </div>
            {/* <GoogleReviewsCustom /> */}
          </div>
        )}
        
    </>
  );
}
